import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import trailConditionsSrc from './images/trail-conditions-thumb.avif';

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
const trailConditions = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Trail Conditions' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Check trail-specific weather, snow depth, and more' }),
  thumbnailImage: trailConditionsSrc.src
});

export default trailConditions;
